export const light = {
  accent: '#2172a9',
  appbar: '#ffffff',
  background_dark: '#72726a',
  background_light: '#fbfbfb',
  background_medium: '#f4f4f1',
  error: '#ff5353',
  grey: '#344060',
  highcontrast_dark: '#e0eef6',
  highcontrast_light: '#150023',
  info: '#009ccb',
  lowcontrast_dark: '#abb3cc',
  lowcontrast_light: '#57699f',
  mediumcontrast_dark: '#a3b5c1',
  mediumcontrast_light: '#353f72',
  primary_dark: '#003459',
  primary_light: '#006fba',
  primary: '#00538c',
  secondary_dark: '#f9bf01',
  secondary_light: '#feda62',
  secondary: '#fece2f',
  success: '#00b27c',
  warning: '#ffa246',
}
